<script lang="ts">
  import {Icon} from '@/components';
  import type {Configuration} from '@/types/settings';
  import dayjs from 'dayjs';
  import {createEventDispatcher} from 'svelte';
  import {YtdlpAddCookieModalForm} from '.';

  export let configuration: Configuration;
  export let isLoading: boolean;

  let addModalOpen = false;
  const dispatch = createEventDispatcher<{
    deleteCookie: string;
  }>();

  const handleDeleteCookie = (fileName: string) => {
    dispatch('deleteCookie', fileName);
  };

  $: files = configuration.options.files ?? [];
</script>

{#if addModalOpen}
  <YtdlpAddCookieModalForm on:addCookie on:close={() => (addModalOpen = false)} />
{/if}
<div class="w-full overflow-hidden rounded-lg bg-white shadow-lg">
  <div class="flex items-center justify-between border-b border-gray-200 bg-white px-6 py-4">
    <h2 class="text-xl font-bold uppercase text-sermon-base-600">{configuration.type} - Cookies</h2>
    <button class="btn btn-primary" on:click={() => (addModalOpen = true)}>
      <Icon name="Plus" className="h-4 w-4" />
      Add Cookie
    </button>
  </div>

  <div class="overflow-x-auto">
    <table class="min-w-full divide-y divide-gray-200">
      <thead class="bg-gray-50">
        <tr>
          <th scope="col" class="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500">
            File Name
          </th>
          <th scope="col" class="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500">
            Created At
          </th>
          <th scope="col" class="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500">
            Updated At
          </th>
          <th scope="col" class="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500">
            Status
          </th>
        </tr>
      </thead>
      <tbody class="divide-y divide-gray-200 bg-white">
        {#if isLoading}
          <tr>
            <td colspan="4" class="py-20">
              <div class="flex justify-center">
                <Icon name="Spinner" className="text-sermon-pink w-6 h-6 animate-spin" />
              </div>
            </td>
          </tr>
        {:else}
          {#each files as file}
            <tr class="transition-colors duration-200 hover:bg-gray-50">
              <td class="whitespace-nowrap px-6 py-4">
                <div class="text-sm font-medium text-sermon-base-600">{file.name}</div>
              </td>
              <td class="whitespace-nowrap px-6 py-4">
                <div class="text-sm text-sermon-base-300">{dayjs(file.createdAt).format('YYYY-MM-DD hh:mm a')}</div>
              </td>
              <td class="whitespace-nowrap px-6 py-4">
                <div class="text-sm text-sermon-base-300">{dayjs(file.updatedAt).format('YYYY-MM-DD hh:mm a')}</div>
              </td>
              <td class="whitespace-nowrap px-6 py-4">
                <button class="text-red-500" on:click={() => handleDeleteCookie(file.name)}>
                  <Icon name="Trash" />
                </button>
              </td>
            </tr>
          {/each}
        {/if}
      </tbody>
    </table>
  </div>
</div>
